import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Objectives = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Box>
      <Box
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #eee",
        }}
      >
        <span style={{ color: "#777", marginBottom: "10px", fontSize: "18px" }}>
          {t("homepage.about_project")}
        </span>
        <h1
          style={{
            fontSize: "28px",
            color: "#333",
            letterSpacing: "1px",
            textTransform: "uppercase",
            fontWeight: "600",
            margin: 0,
          }}
        >
          {t("about_us.goals.project_goal")}
        </h1>
      </Box>

      <Box className="content" sx={{ paddingX: isMobile ? 4 : 24, paddingY: isMobile ? 1 : 3 }}>
        {/* <span style={{ color: "#555", fontWeight: "500" }}>Širi cilj:</span> */}
        <p
          style={{
            lineHeight: "1.8",
            textAlign: "justify",
            marginBottom: "30px",
            color: "#555",
          }}
        >
          {t("about_us.goals.first_parag")}
        </p>
        <p
          style={{
            lineHeight: "1.8",
            textAlign: "justify",
            marginBottom: "30px",
            color: "#555",
          }}
        >
          {t("about_us.goals.second_parag")}
        </p>
        <p
          style={{
            lineHeight: "1.8",
            textAlign: "justify",
            marginBottom: "30px",
            color: "#555",
          }}
        >
          {t("about_us.goals.third_parag")}
        </p>
      </Box>
    </Box>
  );
};

export default Objectives;
